export const enhanceTopicNames = str => {
    return str
        .replace(/-/g, " ")
        .replace("oauth", "OAuth")
        .replace("sso", "SSO")
        .replace("api", "API")
        .replace("mfa", "MFA")
        .replace("howtos", "How-tos")
        .replace("openid", "OpenID")
        .replace("haAPI", "HAAPI")
        .replace("White Papers And Guides", "Whitepapers")
        .replace("neo security", "Neo Security")
        .replace("getting started", "Getting Started")
        .replace("financial grade", "Financial Grade")
        .replace("deployment and operation", "Deployment")
        .replace("claims", "Claims")
        .replace("user management", "User Management")
        .replace("code examples", "Code Examples")
        .replace("operation and configuration", "Operation and configuration")
        .replace("decentralized identities", "Decentralized Identities")
        .replace("security architecture best practices", "Security Architecture Best Practices");
};

export const isDocsTopic = topic => {
    const topics = [
        "Authentication Service Admin Guide",
        "Application Service Admin Guide",
        "Token Service Admin Guide",
        "User Management Admin Guide",
        "Configuration Guide",
        "Developer Guide",
        "System Admin Guide"
    ];

    if (topics.includes(topic)) {
        return true;
    }
};
